// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_postcss@8.5.15_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_postcss@8.5.15_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-manage {

    width: 100%;
}





/* 상단 */

.user-top-bar {

    display: flex;

    justify-content: space-between;

    align-items: center;

    gap: 20px;

    margin-bottom: 28px;

    flex-wrap: wrap;
}





/* 검색 영역 */

.user-search-wrap {

    flex: 1 1;

    display: flex;

    gap: 12px;
}





.user-search-input {

    flex: 1 1;

    height: 54px;

    padding: 0 20px;

    border: none;

    outline: none;

    border-radius: 18px;

    background:

            rgba(255,255,255,0.05);

    border:

            1px solid rgba(255,255,255,0.08);

    color: white;

    font-size: 15px;

    backdrop-filter: blur(20px);

    transition: all 0.25s ease;
}





.user-search-input:focus {

    border-color:

            rgba(124,58,237,0.34);

    box-shadow:

            0 0 0 4px rgba(124,58,237,0.10);
}





.user-search-input::placeholder {

    color:

            rgba(255,255,255,0.38);
}





/* 검색 버튼 */

.user-search-button {

    height: 54px;

    padding: 0 22px;

    border: none;

    border-radius: 18px;

    background:

            linear-gradient(
                    135deg,
                    #7c3aed,
                    #0ea5e9
            );

    color: white;

    font-size: 14px;

    font-weight: 700;

    cursor: pointer;

    transition: all 0.25s ease;
}





.user-search-button:hover {

    transform: translateY(-2px);

    box-shadow:

            0 10px 24px rgba(124,58,237,0.24);
}





/* 전체 회원 수 */

.user-count {

    color:

            rgba(255,255,255,0.55);

    font-size: 14px;

    font-weight: 600;
}





/* 리스트 */

.user-list {

    display: flex;

    flex-direction: column;

    gap: 18px;
}





/* 카드 */

.user-card {

    padding: 28px;

    border-radius: 28px;

    background:

            linear-gradient(
                    180deg,
                    rgba(255,255,255,0.05),
                    rgba(255,255,255,0.02)
            );

    border:

            1px solid rgba(255,255,255,0.06);

    display: flex;

    justify-content: space-between;

    align-items: center;

    gap: 24px;

    transition: all 0.25s ease;

    backdrop-filter: blur(24px);
}





.user-card:hover {

    transform: translateY(-2px);

    border-color:

            rgba(124,58,237,0.24);

    background:

            linear-gradient(
                    180deg,
                    rgba(124,58,237,0.08),
                    rgba(255,255,255,0.03)
            );
}





/* 유저 정보 */

.user-info {

    flex: 1 1;
}





.user-nickname {

    color: white;

    font-size: 22px;

    font-weight: 800;

    letter-spacing: -0.03em;
}





.user-email {

    margin-top: 10px;

    color:

            rgba(255,255,255,0.52);

    font-size: 14px;

    line-height: 1.5;
}





.user-role {

    margin-top: 12px;

    display: inline-flex;

    align-items: center;

    justify-content: center;

    height: 34px;

    padding: 0 14px;

    border-radius: 999px;

    background:

            rgba(14,165,233,0.12);

    border:

            1px solid rgba(14,165,233,0.22);

    color: #38bdf8;

    font-size: 12px;

    font-weight: 800;

    letter-spacing: 0.02em;
}





/* 버튼 영역 */

.user-actions {

    display: flex;

    gap: 10px;

    flex-shrink: 0;
}





/* 수정 버튼 */

.edit-button {

    height: 44px;

    padding: 0 18px;

    border: none;

    border-radius: 16px;

    background:

            linear-gradient(
                    135deg,
                    #7c3aed,
                    #8b5cf6
            );

    color: white;

    font-size: 13px;

    font-weight: 700;

    cursor: pointer;

    transition: all 0.25s ease;
}





.edit-button:hover {

    transform: translateY(-2px);

    box-shadow:

            0 10px 24px rgba(124,58,237,0.26);
}





/* 삭제 버튼 */

.delete-button {

    height: 44px;

    padding: 0 18px;

    border: none;

    border-radius: 16px;

    background:

            rgba(239,68,68,0.16);

    border:

            1px solid rgba(239,68,68,0.28);

    color: #f87171;

    font-size: 13px;

    font-weight: 700;

    cursor: pointer;

    transition: all 0.25s ease;
}





.delete-button:hover {

    transform: translateY(-2px);

    background:

            rgba(239,68,68,0.22);
}





/* 팝업 배경 */

.user-modal-overlay {

    position: fixed;

    top: 0;

    left: 0;

    width: 100%;

    height: 100%;

    background:

            rgba(0,0,0,0.62);

    display: flex;

    align-items: center;

    justify-content: center;

    z-index: 9999;

    backdrop-filter: blur(8px);
}





/* 팝업 */

.user-modal {

    width: 100%;

    max-width: 460px;

    padding: 34px;

    border-radius: 30px;

    background:

            linear-gradient(
                    180deg,
                    rgba(20,20,20,0.98),
                    rgba(12,12,12,0.98)
            );

    border:

            1px solid rgba(255,255,255,0.08);

    box-shadow:

            0 24px 64px rgba(0,0,0,0.44);
}





/* 팝업 제목 */

.modal-title {

    color: white;

    font-size: 28px;

    font-weight: 900;

    letter-spacing: -0.04em;

    margin-bottom: 24px;
}





/* 입력 */

.modal-input,

.modal-select {

    width: 100%;

    height: 58px;

    margin-bottom: 18px;

    padding: 0 18px;

    border: none;

    outline: none;

    border-radius: 18px;

    background:

            rgba(255,255,255,0.05);

    border:

            1px solid rgba(255,255,255,0.08);

    color: white;

    font-size: 15px;

    transition: all 0.25s ease;
}





.modal-input:focus,

.modal-select:focus {

    border-color:

            rgba(124,58,237,0.34);

    box-shadow:

            0 0 0 4px rgba(124,58,237,0.10);
}





.modal-select option {

    background: #111;

    color: white;
}





/* 버튼 */

.modal-buttons {

    display: flex;

    gap: 12px;

    margin-top: 10px;
}





.save-button,

.cancel-button {

    flex: 1 1;

    height: 56px;

    border: none;

    border-radius: 18px;

    color: white;

    font-size: 14px;

    font-weight: 700;

    cursor: pointer;

    transition: all 0.25s ease;
}





.save-button {

    background:

            linear-gradient(
                    135deg,
                    #7c3aed,
                    #0ea5e9
            );
}





.save-button:hover {

    transform: translateY(-2px);

    box-shadow:

            0 10px 28px rgba(124,58,237,0.24);
}





.cancel-button {

    background:

            rgba(255,255,255,0.08);
}





.cancel-button:hover {

    background:

            rgba(255,255,255,0.12);
}





/* 모바일 */

@media screen and (max-width: 768px) {

    .user-top-bar {

        flex-direction: column;

        align-items: stretch;
    }





    .user-search-wrap {

        width: 100%;
    }





    .user-count {

        font-size: 13px;
    }





    .user-card {

        flex-direction: column;

        align-items: flex-start;

        padding: 22px;
    }





    .user-actions {

        width: 100%;

        margin-top: 18px;
    }





    .edit-button,

    .delete-button {

        flex: 1 1;
    }





    .user-modal {

        width: calc(100% - 24px);

        padding: 24px;

        border-radius: 24px;
    }





    .modal-title {

        font-size: 24px;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/components/UserManage.css"],"names":[],"mappings":"AAAA;;IAEI,WAAW;AACf;;;;;;AAMA,OAAO;;AAEP;;IAEI,aAAa;;IAEb,8BAA8B;;IAE9B,mBAAmB;;IAEnB,SAAS;;IAET,mBAAmB;;IAEnB,eAAe;AACnB;;;;;;AAMA,UAAU;;AAEV;;IAEI,SAAO;;IAEP,aAAa;;IAEb,SAAS;AACb;;;;;;AAMA;;IAEI,SAAO;;IAEP,YAAY;;IAEZ,eAAe;;IAEf,YAAY;;IAEZ,aAAa;;IAEb,mBAAmB;;IAEnB;;kCAE8B;;IAE9B;;4CAEwC;;IAExC,YAAY;;IAEZ,eAAe;;IAEf,2BAA2B;;IAE3B,0BAA0B;AAC9B;;;;;;AAMA;;IAEI;;iCAE6B;;IAE7B;;2CAEuC;AAC3C;;;;;;AAMA;;IAEI;;kCAE8B;AAClC;;;;;;AAMA,UAAU;;AAEV;;IAEI,YAAY;;IAEZ,eAAe;;IAEf,YAAY;;IAEZ,mBAAmB;;IAEnB;;;;;;aAMS;;IAET,YAAY;;IAEZ,eAAe;;IAEf,gBAAgB;;IAEhB,eAAe;;IAEf,0BAA0B;AAC9B;;;;;;AAMA;;IAEI,2BAA2B;;IAE3B;;6CAEyC;AAC7C;;;;;;AAMA,YAAY;;AAEZ;;IAEI;;kCAE8B;;IAE9B,eAAe;;IAEf,gBAAgB;AACpB;;;;;;AAMA,QAAQ;;AAER;;IAEI,aAAa;;IAEb,sBAAsB;;IAEtB,SAAS;AACb;;;;;;AAMA,OAAO;;AAEP;;IAEI,aAAa;;IAEb,mBAAmB;;IAEnB;;;;;;aAMS;;IAET;;4CAEwC;;IAExC,aAAa;;IAEb,8BAA8B;;IAE9B,mBAAmB;;IAEnB,SAAS;;IAET,0BAA0B;;IAE1B,2BAA2B;AAC/B;;;;;;AAMA;;IAEI,2BAA2B;;IAE3B;;iCAE6B;;IAE7B;;;;;;aAMS;AACb;;;;;;AAMA,UAAU;;AAEV;;IAEI,SAAO;AACX;;;;;;AAMA;;IAEI,YAAY;;IAEZ,eAAe;;IAEf,gBAAgB;;IAEhB,uBAAuB;AAC3B;;;;;;AAMA;;IAEI,gBAAgB;;IAEhB;;kCAE8B;;IAE9B,eAAe;;IAEf,gBAAgB;AACpB;;;;;;AAMA;;IAEI,gBAAgB;;IAEhB,oBAAoB;;IAEpB,mBAAmB;;IAEnB,uBAAuB;;IAEvB,YAAY;;IAEZ,eAAe;;IAEf,oBAAoB;;IAEpB;;iCAE6B;;IAE7B;;2CAEuC;;IAEvC,cAAc;;IAEd,eAAe;;IAEf,gBAAgB;;IAEhB,sBAAsB;AAC1B;;;;;;AAMA,UAAU;;AAEV;;IAEI,aAAa;;IAEb,SAAS;;IAET,cAAc;AAClB;;;;;;AAMA,UAAU;;AAEV;;IAEI,YAAY;;IAEZ,eAAe;;IAEf,YAAY;;IAEZ,mBAAmB;;IAEnB;;;;;;aAMS;;IAET,YAAY;;IAEZ,eAAe;;IAEf,gBAAgB;;IAEhB,eAAe;;IAEf,0BAA0B;AAC9B;;;;;;AAMA;;IAEI,2BAA2B;;IAE3B;;6CAEyC;AAC7C;;;;;;AAMA,UAAU;;AAEV;;IAEI,YAAY;;IAEZ,eAAe;;IAEf,YAAY;;IAEZ,mBAAmB;;IAEnB;;gCAE4B;;IAE5B;;0CAEsC;;IAEtC,cAAc;;IAEd,eAAe;;IAEf,gBAAgB;;IAEhB,eAAe;;IAEf,0BAA0B;AAC9B;;;;;;AAMA;;IAEI,2BAA2B;;IAE3B;;gCAE4B;AAChC;;;;;;AAMA,UAAU;;AAEV;;IAEI,eAAe;;IAEf,MAAM;;IAEN,OAAO;;IAEP,WAAW;;IAEX,YAAY;;IAEZ;;4BAEwB;;IAExB,aAAa;;IAEb,mBAAmB;;IAEnB,uBAAuB;;IAEvB,aAAa;;IAEb,0BAA0B;AAC9B;;;;;;AAMA,OAAO;;AAEP;;IAEI,WAAW;;IAEX,gBAAgB;;IAEhB,aAAa;;IAEb,mBAAmB;;IAEnB;;;;;;aAMS;;IAET;;4CAEwC;;IAExC;;wCAEoC;AACxC;;;;;;AAMA,UAAU;;AAEV;;IAEI,YAAY;;IAEZ,eAAe;;IAEf,gBAAgB;;IAEhB,uBAAuB;;IAEvB,mBAAmB;AACvB;;;;;;AAMA,OAAO;;AAEP;;;;IAII,WAAW;;IAEX,YAAY;;IAEZ,mBAAmB;;IAEnB,eAAe;;IAEf,YAAY;;IAEZ,aAAa;;IAEb,mBAAmB;;IAEnB;;kCAE8B;;IAE9B;;4CAEwC;;IAExC,YAAY;;IAEZ,eAAe;;IAEf,0BAA0B;AAC9B;;;;;;AAMA;;;;IAII;;iCAE6B;;IAE7B;;2CAEuC;AAC3C;;;;;;AAMA;;IAEI,gBAAgB;;IAEhB,YAAY;AAChB;;;;;;AAMA,OAAO;;AAEP;;IAEI,aAAa;;IAEb,SAAS;;IAET,gBAAgB;AACpB;;;;;;AAMA;;;;IAII,SAAO;;IAEP,YAAY;;IAEZ,YAAY;;IAEZ,mBAAmB;;IAEnB,YAAY;;IAEZ,eAAe;;IAEf,gBAAgB;;IAEhB,eAAe;;IAEf,0BAA0B;AAC9B;;;;;;AAMA;;IAEI;;;;;;aAMS;AACb;;;;;;AAMA;;IAEI,2BAA2B;;IAE3B;;6CAEyC;AAC7C;;;;;;AAMA;;IAEI;;kCAE8B;AAClC;;;;;;AAMA;;IAEI;;kCAE8B;AAClC;;;;;;AAMA,QAAQ;;AAER;;IAEI;;QAEI,sBAAsB;;QAEtB,oBAAoB;IACxB;;;;;;IAMA;;QAEI,WAAW;IACf;;;;;;IAMA;;QAEI,eAAe;IACnB;;;;;;IAMA;;QAEI,sBAAsB;;QAEtB,uBAAuB;;QAEvB,aAAa;IACjB;;;;;;IAMA;;QAEI,WAAW;;QAEX,gBAAgB;IACpB;;;;;;IAMA;;;;QAII,SAAO;IACX;;;;;;IAMA;;QAEI,wBAAwB;;QAExB,aAAa;;QAEb,mBAAmB;IACvB;;;;;;IAMA;;QAEI,eAAe;IACnB;AACJ","sourcesContent":[".user-manage {\n\n    width: 100%;\n}\n\n\n\n\n\n/* 상단 */\n\n.user-top-bar {\n\n    display: flex;\n\n    justify-content: space-between;\n\n    align-items: center;\n\n    gap: 20px;\n\n    margin-bottom: 28px;\n\n    flex-wrap: wrap;\n}\n\n\n\n\n\n/* 검색 영역 */\n\n.user-search-wrap {\n\n    flex: 1;\n\n    display: flex;\n\n    gap: 12px;\n}\n\n\n\n\n\n.user-search-input {\n\n    flex: 1;\n\n    height: 54px;\n\n    padding: 0 20px;\n\n    border: none;\n\n    outline: none;\n\n    border-radius: 18px;\n\n    background:\n\n            rgba(255,255,255,0.05);\n\n    border:\n\n            1px solid rgba(255,255,255,0.08);\n\n    color: white;\n\n    font-size: 15px;\n\n    backdrop-filter: blur(20px);\n\n    transition: all 0.25s ease;\n}\n\n\n\n\n\n.user-search-input:focus {\n\n    border-color:\n\n            rgba(124,58,237,0.34);\n\n    box-shadow:\n\n            0 0 0 4px rgba(124,58,237,0.10);\n}\n\n\n\n\n\n.user-search-input::placeholder {\n\n    color:\n\n            rgba(255,255,255,0.38);\n}\n\n\n\n\n\n/* 검색 버튼 */\n\n.user-search-button {\n\n    height: 54px;\n\n    padding: 0 22px;\n\n    border: none;\n\n    border-radius: 18px;\n\n    background:\n\n            linear-gradient(\n                    135deg,\n                    #7c3aed,\n                    #0ea5e9\n            );\n\n    color: white;\n\n    font-size: 14px;\n\n    font-weight: 700;\n\n    cursor: pointer;\n\n    transition: all 0.25s ease;\n}\n\n\n\n\n\n.user-search-button:hover {\n\n    transform: translateY(-2px);\n\n    box-shadow:\n\n            0 10px 24px rgba(124,58,237,0.24);\n}\n\n\n\n\n\n/* 전체 회원 수 */\n\n.user-count {\n\n    color:\n\n            rgba(255,255,255,0.55);\n\n    font-size: 14px;\n\n    font-weight: 600;\n}\n\n\n\n\n\n/* 리스트 */\n\n.user-list {\n\n    display: flex;\n\n    flex-direction: column;\n\n    gap: 18px;\n}\n\n\n\n\n\n/* 카드 */\n\n.user-card {\n\n    padding: 28px;\n\n    border-radius: 28px;\n\n    background:\n\n            linear-gradient(\n                    180deg,\n                    rgba(255,255,255,0.05),\n                    rgba(255,255,255,0.02)\n            );\n\n    border:\n\n            1px solid rgba(255,255,255,0.06);\n\n    display: flex;\n\n    justify-content: space-between;\n\n    align-items: center;\n\n    gap: 24px;\n\n    transition: all 0.25s ease;\n\n    backdrop-filter: blur(24px);\n}\n\n\n\n\n\n.user-card:hover {\n\n    transform: translateY(-2px);\n\n    border-color:\n\n            rgba(124,58,237,0.24);\n\n    background:\n\n            linear-gradient(\n                    180deg,\n                    rgba(124,58,237,0.08),\n                    rgba(255,255,255,0.03)\n            );\n}\n\n\n\n\n\n/* 유저 정보 */\n\n.user-info {\n\n    flex: 1;\n}\n\n\n\n\n\n.user-nickname {\n\n    color: white;\n\n    font-size: 22px;\n\n    font-weight: 800;\n\n    letter-spacing: -0.03em;\n}\n\n\n\n\n\n.user-email {\n\n    margin-top: 10px;\n\n    color:\n\n            rgba(255,255,255,0.52);\n\n    font-size: 14px;\n\n    line-height: 1.5;\n}\n\n\n\n\n\n.user-role {\n\n    margin-top: 12px;\n\n    display: inline-flex;\n\n    align-items: center;\n\n    justify-content: center;\n\n    height: 34px;\n\n    padding: 0 14px;\n\n    border-radius: 999px;\n\n    background:\n\n            rgba(14,165,233,0.12);\n\n    border:\n\n            1px solid rgba(14,165,233,0.22);\n\n    color: #38bdf8;\n\n    font-size: 12px;\n\n    font-weight: 800;\n\n    letter-spacing: 0.02em;\n}\n\n\n\n\n\n/* 버튼 영역 */\n\n.user-actions {\n\n    display: flex;\n\n    gap: 10px;\n\n    flex-shrink: 0;\n}\n\n\n\n\n\n/* 수정 버튼 */\n\n.edit-button {\n\n    height: 44px;\n\n    padding: 0 18px;\n\n    border: none;\n\n    border-radius: 16px;\n\n    background:\n\n            linear-gradient(\n                    135deg,\n                    #7c3aed,\n                    #8b5cf6\n            );\n\n    color: white;\n\n    font-size: 13px;\n\n    font-weight: 700;\n\n    cursor: pointer;\n\n    transition: all 0.25s ease;\n}\n\n\n\n\n\n.edit-button:hover {\n\n    transform: translateY(-2px);\n\n    box-shadow:\n\n            0 10px 24px rgba(124,58,237,0.26);\n}\n\n\n\n\n\n/* 삭제 버튼 */\n\n.delete-button {\n\n    height: 44px;\n\n    padding: 0 18px;\n\n    border: none;\n\n    border-radius: 16px;\n\n    background:\n\n            rgba(239,68,68,0.16);\n\n    border:\n\n            1px solid rgba(239,68,68,0.28);\n\n    color: #f87171;\n\n    font-size: 13px;\n\n    font-weight: 700;\n\n    cursor: pointer;\n\n    transition: all 0.25s ease;\n}\n\n\n\n\n\n.delete-button:hover {\n\n    transform: translateY(-2px);\n\n    background:\n\n            rgba(239,68,68,0.22);\n}\n\n\n\n\n\n/* 팝업 배경 */\n\n.user-modal-overlay {\n\n    position: fixed;\n\n    top: 0;\n\n    left: 0;\n\n    width: 100%;\n\n    height: 100%;\n\n    background:\n\n            rgba(0,0,0,0.62);\n\n    display: flex;\n\n    align-items: center;\n\n    justify-content: center;\n\n    z-index: 9999;\n\n    backdrop-filter: blur(8px);\n}\n\n\n\n\n\n/* 팝업 */\n\n.user-modal {\n\n    width: 100%;\n\n    max-width: 460px;\n\n    padding: 34px;\n\n    border-radius: 30px;\n\n    background:\n\n            linear-gradient(\n                    180deg,\n                    rgba(20,20,20,0.98),\n                    rgba(12,12,12,0.98)\n            );\n\n    border:\n\n            1px solid rgba(255,255,255,0.08);\n\n    box-shadow:\n\n            0 24px 64px rgba(0,0,0,0.44);\n}\n\n\n\n\n\n/* 팝업 제목 */\n\n.modal-title {\n\n    color: white;\n\n    font-size: 28px;\n\n    font-weight: 900;\n\n    letter-spacing: -0.04em;\n\n    margin-bottom: 24px;\n}\n\n\n\n\n\n/* 입력 */\n\n.modal-input,\n\n.modal-select {\n\n    width: 100%;\n\n    height: 58px;\n\n    margin-bottom: 18px;\n\n    padding: 0 18px;\n\n    border: none;\n\n    outline: none;\n\n    border-radius: 18px;\n\n    background:\n\n            rgba(255,255,255,0.05);\n\n    border:\n\n            1px solid rgba(255,255,255,0.08);\n\n    color: white;\n\n    font-size: 15px;\n\n    transition: all 0.25s ease;\n}\n\n\n\n\n\n.modal-input:focus,\n\n.modal-select:focus {\n\n    border-color:\n\n            rgba(124,58,237,0.34);\n\n    box-shadow:\n\n            0 0 0 4px rgba(124,58,237,0.10);\n}\n\n\n\n\n\n.modal-select option {\n\n    background: #111;\n\n    color: white;\n}\n\n\n\n\n\n/* 버튼 */\n\n.modal-buttons {\n\n    display: flex;\n\n    gap: 12px;\n\n    margin-top: 10px;\n}\n\n\n\n\n\n.save-button,\n\n.cancel-button {\n\n    flex: 1;\n\n    height: 56px;\n\n    border: none;\n\n    border-radius: 18px;\n\n    color: white;\n\n    font-size: 14px;\n\n    font-weight: 700;\n\n    cursor: pointer;\n\n    transition: all 0.25s ease;\n}\n\n\n\n\n\n.save-button {\n\n    background:\n\n            linear-gradient(\n                    135deg,\n                    #7c3aed,\n                    #0ea5e9\n            );\n}\n\n\n\n\n\n.save-button:hover {\n\n    transform: translateY(-2px);\n\n    box-shadow:\n\n            0 10px 28px rgba(124,58,237,0.24);\n}\n\n\n\n\n\n.cancel-button {\n\n    background:\n\n            rgba(255,255,255,0.08);\n}\n\n\n\n\n\n.cancel-button:hover {\n\n    background:\n\n            rgba(255,255,255,0.12);\n}\n\n\n\n\n\n/* 모바일 */\n\n@media screen and (max-width: 768px) {\n\n    .user-top-bar {\n\n        flex-direction: column;\n\n        align-items: stretch;\n    }\n\n\n\n\n\n    .user-search-wrap {\n\n        width: 100%;\n    }\n\n\n\n\n\n    .user-count {\n\n        font-size: 13px;\n    }\n\n\n\n\n\n    .user-card {\n\n        flex-direction: column;\n\n        align-items: flex-start;\n\n        padding: 22px;\n    }\n\n\n\n\n\n    .user-actions {\n\n        width: 100%;\n\n        margin-top: 18px;\n    }\n\n\n\n\n\n    .edit-button,\n\n    .delete-button {\n\n        flex: 1;\n    }\n\n\n\n\n\n    .user-modal {\n\n        width: calc(100% - 24px);\n\n        padding: 24px;\n\n        border-radius: 24px;\n    }\n\n\n\n\n\n    .modal-title {\n\n        font-size: 24px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
